import React from 'react';

import { makePrioStyles } from '../../../theme/utils';
import Flex from '../../../components/Flex';
import GlobalProjectSettingsProjectDocumentPrefix from './GlobalProjectSettingsProjectDocumentPrefix';
import classNames from 'classnames';
import { useTheme } from 'react-jss';
import { PrioTheme } from '../../../theme/types';
import GlobalProjectSettingsProjectDocumentTags from './GlobalProjectSettingsProjectDocumentTags';

const useStyles = makePrioStyles((theme) => ({
  root: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    padding: theme.old.spacing.defaultPadding,
    height: '100%',
    overflowY: 'auto',
  },
  spin: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    height: '100%',
    width: '100%',
  },
  shadow: {
    boxShadow: theme.old.palette.boxShadow.regular,
  },
}));

interface GlobalProjectDocumentSettingsPageProps {
  className?: string;
}

export const GlobalProjectDocumentSettingsPage: React.FC<
  GlobalProjectDocumentSettingsPageProps
> = (props) => {
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  const { className } = props;

  return (
    <div className={classNames(classes.root, className)}>
      <Flex.Column childrenGap={theme.old.spacing.unit(2)}>
        <GlobalProjectSettingsProjectDocumentPrefix
          className={classes.shadow}
        />
        <GlobalProjectSettingsProjectDocumentTags className={classes.shadow} />
      </Flex.Column>
    </div>
  );
};

export default GlobalProjectDocumentSettingsPage;
